import { FC, ReactNode } from 'react'

import {
  Text,
  BorderRadius6,
  GreyGrey40,
  GreyGrey60,
  GreyGrey70,
  GreyGrey90,
  GreyWhite,
  Primary12Regular,
  Primary12SemiBold,
  Primary20SemiBold,
  ShadowXs,
  Flex
} from '@sequencehq/core-components'

type Props = {
  title: string
  value: string
  caption?: string
  control?: ReactNode
  children?: ReactNode
  'data-testid': string
}

export const AnalyticsCard: FC<Props> = ({
  title,
  value,
  caption,
  control,
  children,
  'data-testid': dataTestId
}) => {
  return (
    <Flex
      flexDir="column"
      width="100%"
      padding="12px"
      position="relative"
      gap="12px"
      backgroundColor={GreyWhite}
      borderRadius={BorderRadius6}
      border={`${GreyGrey40} 1px solid`}
      boxShadow={ShadowXs}
      data-testid={dataTestId}
    >
      {control && (
        <Flex
          position="absolute"
          top="8px"
          right="8px"
          data-testid={`${dataTestId}.control`}
        >
          {control}
        </Flex>
      )}

      <Flex flexDir="column" gap="4px">
        <Text
          {...Primary12SemiBold}
          color={GreyGrey70}
          data-testid={`${dataTestId}.title`}
        >
          {title}
        </Text>
        <Text
          {...Primary20SemiBold}
          color={GreyGrey90}
          data-testid={`${dataTestId}.value`}
        >
          {value}
        </Text>
        {caption && (
          <Text
            {...Primary12Regular}
            color={GreyGrey60}
            data-testid={`${dataTestId}.caption`}
          >
            {caption}
          </Text>
        )}
      </Flex>

      {children}
    </Flex>
  )
}
